import { render, staticRenderFns } from "./SortButton.vue?vue&type=template&id=644b30b8&scoped=true"
import script from "./SortButton.vue?vue&type=script&lang=js"
export * from "./SortButton.vue?vue&type=script&lang=js"
import style0 from "./SortButton.vue?vue&type=style&index=0&id=644b30b8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "644b30b8",
  null
  
)

export default component.exports